import { useHistory, useLocation } from 'react-router-dom'
import { selectPlaceData } from '../placeSlice'
import { useReduxSelector } from 'store'
import { useEffect } from 'react'

const key = 'warehouseTypeId'

const useSelectedHash = () => {
  const { sizes, sizeGroups, warehouses } = useReduxSelector(selectPlaceData)
  const { search } = useLocation()
  const query = new URLSearchParams(search)
  const warehouseTypeId = query.get(key)
  const hash = query.get('hash')

  const { replace, push } = useHistory()
  const selectHash = (wariantTypeId: string, hash?: string) => {
    (hash ? push : replace)(`${window.location.pathname}?${key}=${wariantTypeId}${hash ? `&hash=${hash}` : ''}`)
  }

  useEffect(() => {
    if (!sizes?.[0] || warehouseTypeId) return
    const showGroups = sizeGroups?.length > 0
    if (warehouseTypeId && (showGroups
      ? (sizeGroups as any[]).some(size => size.warehouseSizeGroupId === warehouseTypeId)
      : (sizes as any[]).some(size => size.warehouseTypeId === warehouseTypeId))
    ) {
      selectHash(warehouseTypeId)
    } else if (showGroups) {
      selectHash(sizeGroups[0].warehouseSizeGroupId)
    } else {
      const warehouseTypeIdWithAvailableWarehouses = findFirstWarehouseTypeIdWithAvailableWarehouses(sizes, warehouses)
      selectHash(warehouseTypeIdWithAvailableWarehouses)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizes, sizeGroups, warehouses, warehouseTypeId, search])

  return [
    warehouseTypeId,
    hash,
    selectHash
  ] as const
}

const findFirstWarehouseTypeIdWithAvailableWarehouses = (sizes: any[], warehouses: Record<string, Record<string, any>>) => {
  for (const size of sizes) {
    const group = warehouses?.[size.warehouseTypeId]
    if (group) {
      for (const key in group) {
        if (group[key].isAvailableForRentNow) {
          return size.warehouseTypeId
        }
      }
    }
  }

  return sizes[0].warehouseTypeId
}

export default useSelectedHash